import TagManager from "react-gtm-module";

const emailCaptureGA = {
  signInButtonClick: type => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "sign_in",
        event_label: `open|flow:${type}signin`
      }
    });
  },
  signInOpenModal: label => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "sign_in",
        event_label: `open|source=${label}`
      }
    });
  },
  signInCloseModal: label => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "sign_in",
        event_label: `close|source=${label}`
      }
    });
  },
  signInSubmitForm: label => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "sign_in",
        event_label: `submit_button|source=${label}`
      }
    });
  },
  accountIsCreated: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "create_account",
        event_label: `open|source=${label}|flow:${flow}`
      }
    });
  }
};

const confirmationGA = {
  confirmationModalOpens: (label, flow, userType, userId) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "login_confirmation",
        event_label: `open|source=${label}|flow:${flow}`,
        userType: `${userType}`,
        userId: `${userId}`
      }
    });
  },
  confirmationModalOpensSaved: (label, userType, userId) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "login_confirmation",
        event_label: `open|source=${label}|user_type:${userType}`,
        userType: `${userType}`,
        userId: `${userId}`
      }
    });
  },
  confirmationModalOpensBoundary: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "login_confirmation",
        event_label: `open|source=${label}|user_type:${flow}`
      }
    });
  },
  confirmationModalIsClosedSaved: (label, flow, userType, userId) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "login_confirmation",
        event_label: `close|source=${label}|user_type:${flow}`,
        userType: `${userType}`,
        userId: `${userId}`
      }
    });
  },
  confirmationModalIsClosed: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "login_confirmation",
        event_label: `close|source=${label}|flow:${flow}`
      }
    });
  },
  confirmationModalIsClosedBoundary: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "login_confirmation",
        event_label: `close|source=${label}|flow:${flow}`
      }
    });
  }
};

const shareConfirmationGA = {
  shareConfirmationModalOpen: flow => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "share_confirmation",
        event_label: `open|source=share|user_type:${flow}`
      }
    });
  },
  accountIsCreated: flow => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "create_account",
        event_label: `open|source=share|flow:${flow}`
      }
    });
  }
};

const verificationSentGA = {
  welcomeBackModalOpen: label => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "welcome_back",
        event_label: `open|source=${label}|user_type:freepass`
      }
    });
  },
  welcomeBackModalClosed: label => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "welcome_back",
        event_label: `close|source=${label}|user_type:freepass`
      }
    });
  }
};

const setPasswordGA = {
  setPasswordModalOpens: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "set_password",
        event_label: `open|source=${label}|user_type:${flow}`
      }
    });
  },
  setPasswordModalIsClosed: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "set_password",
        event_label: `close|source=${label}|user_type:${flow}`
      }
    });
  },
  userSubmitsValidPassword: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "set_password",
        event_label: `create_password|source=${label}|user_type:${flow}`
      }
    });
  }
};

const confirmationPasswordGA = {
  setPasswordConfirmationModalOpens: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "set_password_confirmation",
        event_label: `open|source=${label}|user_type:${flow}`
      }
    });
  },
  setPasswordConfirmationModalIsClosed: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "set_password_confirmation",
        event_label: `close|source=${label}|user_type:${flow}`
      }
    });
  }
};

const passwordRequestedGA = {
  enterPasswordModalOpens: (label, flow, userType, userId) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "enter_password",
        event_label: `open|source=${label}|user_type:${flow}`,
        userType: `${userType}`,
        userId: `${userId}`
      }
    });
  },
  enterPasswordModalSubmit: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "enter_password",
        event_label: `submit|source=${label}|user_type:${flow}`
      }
    });
  },
  enterPasswordModalIsClosed: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "enter_password",
        event_label: `close|source=${label}|user_type:${flow}`
      }
    });
  }
};

const resetPasswordGA = {
  forgotPasswordModalOpens: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "forgot_password",
        event_label: `open|source=${label}|user_type:${flow}`
      }
    });
  },
  forgotPasswordModalSibmit: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "forgot_password",
        event_label: `submit|source=${label}|user_type:${flow}`
      }
    });
  },
  forgotPasswordModalIsClosed: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "forgot_password",
        event_label: `close|source=${label}|user_type:${flow}`
      }
    });
  }
};

const resetPasswordConfirmationGA = {
  checkEmailModalOpens: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "password_check_email",
        event_label: `open|source=${label}|user_type:${flow}`
      }
    });
  },
  checkEmailModalIsClosed: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "password_check_email",
        event_label: `close|source=${label}|user_type:${flow}`
      }
    });
  }
};

const registerIndustryConfirmationGA = {
  checkEmailModalOpens: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "complete_industry_registration",
        event_label: `open|source=${label}|user_type:${flow}`
      }
    });
  }
};

const itemIsSaved = (itemType, itemId) => {
  TagManager.dataLayer({
    dataLayer: {
      event: "custom_event",
      event_category: "save",
      event_action: `${itemType}`,
      event_label: `${itemId}`
    }
  });
};

const contactConfirmationGA = {
  modalIsOpened: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "contact_confirmation",
        event_label: `open|source=${label}|flow:${flow}`
      }
    });
  },
  modalIsClosed: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "contact_confirmation",
        event_label: `close|source=${label}|flow:${flow}`
      }
    });
  },
  accountIsCreated: (label, flow) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "custom_event",
        event_category: "login",
        event_action: "create_account",
        event_label: `open|source=${label}|flow:${flow}`
      }
    });
  }
};

const boundaryCreatedGA = (label, flow) => {
  TagManager.dataLayer({
    dataLayer: {
      event: "custom_event",
      event_category: "save",
      event_action: "create_boundary",
      event_label: `open|source=${label}|flow:${flow}`
    }
  });
};

export {
  boundaryCreatedGA,
  confirmationGA,
  confirmationPasswordGA,
  contactConfirmationGA,
  emailCaptureGA,
  itemIsSaved,
  passwordRequestedGA,
  registerIndustryConfirmationGA,
  resetPasswordConfirmationGA,
  resetPasswordGA,
  setPasswordGA,
  shareConfirmationGA,
  verificationSentGA
};
